import {filter, map} from 'rxjs/operators';
import {wsMsg$} from '@/ws';
import type {ws} from '@/types';

type SpotMarketMsg = ws.SpotMarketMsg;
type SpotMarketRaw = ws.SpotMarketRaw;
type SpotMarketData = ws.SpotMarketData;

export const spotMarket24hData$ = wsMsg$.pipe(
  filter((o: SpotMarketMsg) => o.method === 'spot_market24h_pack.update'),
  map((o: SpotMarketMsg) => o.data.map(convertSpotMarketItem))
);

function convertSpotMarketItem(item: SpotMarketRaw): SpotMarketData {
  return {
    symbol: item[0],
    openEp: item[1],
    highEp: item[2],
    lowEp: item[3],
    lastEp: item[4],
    volumeEv: item[5],
    turnoverEv: item[6],
    bidEp: item[7],
    askEp: item[8],
    indexEp: item[9],
  };
}
